export default __webpack_public_path__ + "static/media/billy-joel.d0ffe78a.webp";